import TemplateView from '../TemplateView'
import SearchWithDropdownButton from './SearchWithDropdownButton'
import SearchItemList from './SearchItemList'
import {filterEntitiesBySearch} from '../taskManagement/common/utils'
import ScrollableDropdownView from './ScrollableDropdownView'

export default class Combobox extends TemplateView {

    constructor({
        emptySelectionMessageKey = '',
        notFoundMessageKey = '',
        hiddenItemsCollapsedMessageKey = '',
        hiddenItemsExpandedMessageKey = '',
        emptyListMessageKey = '',
        emptySelectionId = -1,
        additionalClass = '',
        positionParams = null,
        hideItemPredicate = () => {},
        onItemSelectedCb = (item) => {},
        onListShowCb = () => {},
        onListHideCb = () => {},
        inputMaxLength,
    }) {
        super()

        this.state = {
            items: [],
            additionalItems: [],
            selectedItemId: emptySelectionId,
            searchText: '',
            emptyListMessageKey: emptyListMessageKey,
        }

        this.params = {
            emptySelectionMessageKey,
            notFoundMessageKey,
            hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey,
            additionalClass,
            emptySelectionId,
            positionParams,
            hideItemPredicate,
            onItemSelectedCb,
            onListShowCb,
            onListHideCb,
            inputMaxLength,
        }

        this.onAnyStatePropertyChanged(
            ['selectedItemId', 'items', 'additionalItems', 'emptyListMessageKey', 'searchText'],
            () => {
                this._updateSearchButton()
                this._updateMenu()
            })
    }

    templateHtml() {
        return '<div class="components_combobox <%-additionalClass%>"></div>'
    }


    afterRender() {
        this.searchButton = new SearchWithDropdownButton({
            emptySelectionMessageKey: this.params.emptySelectionMessageKey,
            dropdownButtonClick: () => {
                if (this.menu.isShown)
                    this.menu.hide()
                else
                    this.searchButton.setState({
                        focused: true,
                        searchText: '',
                    })
            },
            onSearchChangedCallback: (text) => {
                this.setState({
                    searchText: text
                })
            },
            onSearchFocusedCallback: () => {
                this.menu.showAt(this.searchButton.getEl(), this.params.positionParams)
                let selectedItem = this.state.items.find(el => el.id === this.state.selectedItemId)
                if (!!selectedItem && this.params.hideItemPredicate(selectedItem))
                    this.menu.setState({
                        hiddenElementsCollapsed: false,
                    })
                this.menu.scrollTo(".selected")
            },
            onSelectedItemClickCallback: () => {
                const selectedItem = this.state.items.find(el => el.id === this.state.selectedItemId)
                this.searchButton.setState({
                    focused: true,
                    searchText: '',
                })
            },
            renderSelectedItemHtml: (item) => this.renderSelectedItemHtml(item),
            inputMaxLength: this.params.inputMaxLength,
        }).init(this.$el)

        this.menu = new ScrollableDropdownView({
            disableFlip: true,
            onHide: () => {
                this.searchButton.setState({
                    focused: false,
                })
                this.params.onListHideCb()
            },
            onShow: () => {
                this.params.onListShowCb()
            },
            component:
                new SearchItemList({
                    itemRenderer: (item, tokensHighlighter) => this.renderMenuItem(item, tokensHighlighter, this.state.selectedItemId),
                    additionalItemRenderer: (item) => this.renderAdditionalMenuItem(item, this.state.selectedItemId),
                    notFoundMessageKey: this.params.notFoundMessageKey,
                    hiddenItemsCollapsedMessageKey: this.params.hiddenItemsCollapsedMessageKey,
                    hiddenItemsExpandedMessageKey: this.params.hiddenItemsExpandedMessageKey,
                })
        }).init(this.$el)

        this.renderInitialState()
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    renderMenuItem(item, tokensHighlighter, selectedItemId) {

    }

    renderAdditionalMenuItem(item, selectedItemId) {

    }

    renderSelectedItemHtml(item) {
        //abstract
    }

    getMenuEl() {
        return this.menu.getEl()
    }

    _onItemSelected(item) {
        this.menu.hide()
        this.params.onItemSelectedCb(item)
    }

    _updateSearchButton() {
        this.searchButton.setState({
            disabled: this.state.items.length + this.state.additionalItems.length === 0,
            emptySetMessageKey: this.state.emptyListMessageKey,
            emptySelection: this.state.selectedItemId === this.params.emptySelectionId,
            emptySelectionSet: this.state.items.length + this.state.additionalItems.length === 0,
            selectedItem: this.state.items.find(el => el.id === this.state.selectedItemId) ||
                          this.state.additionalItems.find(el => el.id === this.state.selectedItemId)
        })
    }

    _updateMenu() {
        const foundItems = filterEntitiesBySearch(this.state.items.filter(item => !this.params.hideItemPredicate(item)), this.state.searchText)
        const foundHiddenItems = filterEntitiesBySearch(this.state.items.filter(item => this.params.hideItemPredicate(item)), this.state.searchText)
        this.menu.setState({
            searchText: this.state.searchText,
            items: foundItems,
            hiddenItems: foundHiddenItems,
            additionalItems: this.state.additionalItems,
            selectedItemId: this.state.selectedItemId,
        })
        if (!!this.state.searchText && foundHiddenItems.length > 0)
            this.menu.setState({
                hiddenElementsCollapsed: false,
            })
    }
}



// WEBPACK FOOTER //
// ./web/js/components/Combobox.js